import script from "./MintCollateralChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MintCollateralChart.vue?vue&type=script&setup=true&lang=js"

import "./MintCollateralChart.vue?vue&type=style&index=0&id=6af101e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af101e3"]])

export default __exports__